import { MissionType, IMissionData } from '../../../State/Player/IMission';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import IPlayerData from '../../IPlayerData';
import { restoreStringifiedArray } from '../../ParseHelper';
import PlayerProperty from '../PlayerProperty';

export default class Missions extends PlayerProperty<
    IMissionData[],
    {
        missions: string;
    }
> {
    public readonly defaultValue: IMissionData[] = [];
    public restore(playerEndpointData: IPlayerData): IMissionData[] {
        const missionDataValues = restoreStringifiedArray<number>(
            playerEndpointData.missions
        );

        if (!missionDataValues) {
            return this.defaultValue;
        } else {
            const missionData: IMissionData[] = [];
            for (let i = 0, n = missionDataValues.length; i < n; i += 4) {
                // Legacy: ADD_FRIENDS mission is no longer allowed. Ignore it.
                if (missionDataValues[i] === MissionType.ADD_FRIENDS) continue;

                missionData.push({
                    type: missionDataValues[i],
                    target: missionDataValues[i + 1],
                    progress: missionDataValues[i + 2],
                    prize: missionDataValues[i + 3],
                });
            }
            return missionData;
        }
    }

    public save(playerStateData: IPlayerState) {
        // Convert mission data array back to 'missions' array.
        const missionDataValues: number[] = [];
        for (let i = 0, n = playerStateData.missions.length; i < n; i++) {
            missionDataValues.push(playerStateData.missions[i].type);
            missionDataValues.push(playerStateData.missions[i].target);
            missionDataValues.push(playerStateData.missions[i].progress);
            missionDataValues.push(playerStateData.missions[i].prize);
        }

        return { missions: JSON.stringify(missionDataValues) };
    }

    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            this.save(playerStateData).missions !== playerEndpointData.missions
        );
    }
}
